const columns = [{key: 'name', label: 'Poslovalnica'}];

export default columns;
